import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GetAttributePipe } from './pipe/get-attribute.pipe';
import { FormatCurrencyPipe } from './pipe/FormatCurrency.pipe';
@Component({
  selector: 'lib-ge-table',
  templateUrl: './ge-table.component.html',
  styleUrls: ['./ge-table.component.scss'],
  providers: [GetAttributePipe],
})
export class GeTableComponent implements OnInit {
  @Input() headArray: any[] = [];
  @Input() gridArray: any[] = [];
  @Output() actionButton = new EventEmitter<any>();
  @Output() checked = new EventEmitter<any>();
  @Output() allChecked = new EventEmitter<any>();

  @Input() pageNumber: number = 1;
  @Input() pageSize: number = 25;
  @Input() isDragAndDrog: boolean = false;
  @Input() dataPaintRow: any = null;
  @Input() dataPaintColumn: any = null;

  public selectAllItems = false;
  public colorResultsRow: any[] = [];
  public colorResultsColumn: any[] = [];

  maxLengthText: number = 9999999;

  orderByAsc = true;
  limitScroll: number = 10; 

  @ViewChild('topScroll') topScroll: ElementRef | undefined;

  constructor(public attributePipe: GetAttributePipe,
    public formatCurrencyPipe : FormatCurrencyPipe
  ) {}

  ngOnInit(): void {
    if (this.gridArray?.length < 1) {
      this.gridArray = [{}];
      this.isDragAndDrog = false;
    } else {
      for (const item of this.gridArray) {
        if (typeof item.checked !== 'undefined' && item.checked === true) {
          this.fieldsChange({ currentTarget: { checked: item.checked } }, item);
        }
      }
    }
    this.colorResultsRow = [];
    this.colorResultsColumn = [];
    this.initializeColorResults();
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  sortColumn(head: {
    FieldName: string;
    Attribute?: string;
    renderValue?: Function;
    OrderValue?: Function;
  }) {
    const property = head.Attribute
      ? head.FieldName + '.' + head.Attribute
      : head.FieldName;
    // Cambia la dirección de ordenación
    this.orderByAsc = !this.orderByAsc;

    // Ordena el array gridArray alfabéticamente en función del campo especificado (fieldName)
    this.gridArray.sort((a, b) => {
      let valueA, valueB;
      if (head.OrderValue) {
        valueA = head.OrderValue(a);
        valueB = head.OrderValue(b);
      } else if (head.renderValue) {
        valueA = head.renderValue(a);
        valueB = head.renderValue(b);
      } else {
        valueA = this.attributePipe.getPropertyValue(a, property);
        valueB = this.attributePipe.getPropertyValue(b, property);
      }
      
      // Fechas tipo Date
    if (valueA instanceof Date && valueB instanceof Date) {
      const diff = valueA.getTime() - valueB.getTime();
      return this.orderByAsc ? diff : -diff;
    }

    //Fechas tipo string dd/mm/yyyy
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      const fechaA = this.formatCurrencyPipe.parseFechaString(valueA);
      const fechaB = this.formatCurrencyPipe.parseFechaString(valueB);

      if (fechaA !== null && fechaB !== null) {
        const diff = fechaA - fechaB;
        return this.orderByAsc ? diff : -diff;
      }
    }

    // Numeros (reales o strings numéricas puras)
    const isNumberA =
      typeof valueA === 'number' ||
      (typeof valueA === 'string' && /^\d+([.,]\d+)?$/.test(valueA));
    const isNumberB =
      typeof valueB === 'number' ||
      (typeof valueB === 'string' && /^\d+([.,]\d+)?$/.test(valueB));

    if (isNumberA && isNumberB) {
      const nA =
        typeof valueA === 'number'
          ? valueA
          : Number(this.formatCurrencyPipe.normalizeNumber(valueA));
      const nB =
        typeof valueB === 'number'
          ? valueB
          : Number(this.formatCurrencyPipe.normalizeNumber(valueB));

      const diff = nA - nB;
      return this.orderByAsc ? diff : -diff;
    }

    // Texto alfanumerico
    const result = String(valueA ?? '').localeCompare(
      String(valueB ?? ''),
      'es-ES',
      {
        numeric: true,
        sensitivity: 'base',
        ignorePunctuation: true
      }
    );

    return this.orderByAsc ? result : -result;
  });
  }

  actions(item: any, name: any) {
    item['nameButton'] = name;
    this.actionButton.emit(item);
  }

  fieldsChange(event: any, item: any): void {
    if (item['checked'] === null) {
      item['checked'] = false;
    } else {
      item['checked'] = event.currentTarget.checked;
      this.checked.emit(item);
    }
  }

  selectAllRows(event: any, gridArray: any) {
    this.selectAllItems = event.currentTarget.checked;
    const gridArrayAux = gridArray.map((item: any) => {
      item['checked'] = this.selectAllItems;
      return item;
    });
    this.allChecked.emit(gridArrayAux);
  }

  onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.gridArray, event.previousIndex, event.currentIndex);
    this.gridArray.forEach((gridArray, idx) => {
      gridArray.order = idx + 1;
    });
  }

  isEmpty(obj: any): boolean {
    if (Object.keys(obj).length === 0) return true;
    return false;
  }

  getRowColorClassAction(item: any, objlist: any) {
    let colorClass = '';
    let foundColorObject = objlist.optionColor.find(
      (obj: any) => obj.info == item[objlist.fieldName]
    );
    if (foundColorObject) {
      colorClass = foundColorObject.color;
    }
    return colorClass;
  }

  initializeColorResults() {
    if (this.dataPaintColumn !== null && this.gridArray?.length != 0) {
      for (let item of this.gridArray) {
        this.colorResultsColumn.push(
          this.getRowColorClassAction(item, this.dataPaintColumn)
        );
      }
    }
    if (this.dataPaintRow !== null && this.gridArray?.length != 0) {
      for (let item of this.gridArray) {
        this.colorResultsRow.push(
          this.getRowColorClassAction(item, this.dataPaintRow)
        );
      }
    }
  }

  shouldShowButton(button: any, item: any): boolean {
    if (button.show) {
      if (typeof button.show == 'function') {
        return button.show(item);
      }

      if (
        item[button.show.params] ||
        button.nameButton == item[button.show.accion]
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  shouldShowModal(arrayBottons: any[], item: any): boolean {
    let shouldShow = false;

    arrayBottons.forEach((button) => {
      if (button.show) {
        if (
          item[button.show.params] ||
          button.nameButton == item[button.show.accion]
        ) {
          shouldShow = true;
        }
      } else {
        shouldShow = true;
      }
    });

    return shouldShow;
  }
// Añade esta función dentro de la clase GeTableComponent
syncScroll(source: any, target: any) {
  if (source && target && source.scrollLeft !== target.scrollLeft) {
    target.scrollLeft = source.scrollLeft;
  }
}
get tieneScroll(): boolean {
  // Aseguramos que hay datos reales antes de ampliar la cabecera
  return this.gridArray && 
         this.gridArray.length > this.limitScroll && 
         !this.isEmpty(this.gridArray[0]);
}
}
